import {Authored} from "./common";

export interface Manufacturer {
  id: string;
  name: string;
  abbreviation: string | null;
  warrantyInMonths: number | null;
  hasSerialNumberByDefault: boolean | null;
  responsible: string[];
  model: string;
  created: Authored;
  updated: Authored;
}

export interface ManufacturerCreateUpdateRequest {
  name: string;
  abbreviation: string;
  warrantyInMonths: number;
  hasSerialNumberByDefault: boolean;
  responsible: string[];
}

export interface ManufacturerResponse {
  name: string;
  foundIn: ManufacturerFoundIn[];
  assigned: Manufacturer | null;
}

export enum ManufacturerFoundIn {
  CATALOG = "CATALOG",
  EQUIPMENT = "EQUIPMENT",
}
